<template>
  <header class="header">
    <transition name="fade" appear>
      <div
        v-show="show.wrapper && show.blur && !show.headerMobile"
        class="mobile-blur"
      ></div>
    </transition>
    <transition name="fromtophead" appear>
      <div
        v-show="show.wrapper"
        class="wrapper"
        :class="{
          inverse: (slug !== undefined && show.blur) || route.name === '404',
        }"
        :style="[
          show.blur && show.headerMobile
            ? 'top:calc(0px - var(--header-main-height))'
            : '',
          show.drawer && !show.headerMobile
            ? 'background: transparent; transition: all 0.6s ease;'
            : '',
        ]"
      >
        <div class="wrapper-top-container">
          <router-link
            :to="$i18nRoute({ name: 'FeedWrapper' })"
            class="nav-item headline"
          >
            <div class="main">
              <img src="@/assets/zamonuz.png" alt="Zamon" />
              Zamon
            </div>
          </router-link>
          <div class="information-block">
            <div class="nav-item">
              <div>
                1 USD=
                {{
                  `${currency.toString().slice(0, 2)} ${currency
                    .toString()
                    .slice(2, 5)}`
                }}
                {{ $t("main.sum") }}
              </div>
            </div>
            <div class="nav-item" style="transform: translate(5%)">
              <i class="fas fa-temperature-low"></i>
              <div>{{ weather }} °C</div>
            </div>
          </div>
        </div>

        <div class="sub-cat-container" ref="container">
          <router-link
            :to="$i18nRoute({ name: 'FeedWrapper' })"
            style="position: relative: height: 100%"
            class="bottom-logo"
            v-show="show.wrapper && show.blur"
          >
            <img src="@/assets/zamonuz.png" alt="Zamon" />
          </router-link>
          <nav
            style="width: auto; height: 100%; display: flex"
            ref="sub_container"
          >
            <router-link
              :to="
                $i18nRoute({
                  name: 'FeedWrapper',
                })
              "
              class="sub-cat-item"
            >
              {{ $t("main.main") }}
            </router-link>
            <router-link
              :to="
                $i18nRoute({
                  name: 'MainWrapper',
                  params: { category: cat.slug },
                })
              "
              v-for="(cat, index) of categories"
              :key="index"
              class="sub-cat-item"
            >
              {{ cat[`name_${i18n.global.locale.value}`] }}
            </router-link>
          </nav>
        </div>
      </div>
    </transition>
    <transition name="fromtophead" appear>
      <div
        :style="[
          show.blur && show.headerMobile
            ? 'top:calc(0px - var(--header-main-height))'
            : '',
          show.drawer ? 'z-index:33' : 'z-index:29',
        ]"
        class="desktop left-hand"
        v-if="route.name?.substring(route.name.length - 10) !== 'NewsDetail'"
        :class="{ headliner: show.drawer }"
      >
        <div class="sided-wrapper-bars-wrapper">
          <div
            class="btn-primary sided-wrapper-bars-wrapper-in"
            @click="show.drawer = !show.drawer"
          >
            <div class="grip-lines">
              <div></div>
              <div></div>
            </div>
            <div class="section">
              {{
                (route.name?.substring(route.name.length - 11) ===
                  "MainWrapper" &&
                  active === undefined) ||
                route.name?.substring(route.name.length - 11) ===
                  "FeedWrapper" ||
                route.name?.substring(route.name.length - 11) !== "MainWrapper"
                  ? $t("main.sections")
                  : getByUnique(active, categories, "slug")?.[
                      `name_${i18n.global.locale.value}`
                    ]
              }}
            </div>
          </div>
        </div>
      </div>
    </transition>
    <transition name="fromtophead" appear>
      <div
        v-show="show.wrapper"
        class="sided-wrapper"
        :class="{
          inverse: (slug !== undefined && show.blur) || route.name === '404',
        }"
        ref="sidedWrapper"
        v-if="
          route.name?.substring(route.name.length - 10) !== 'NewsDetail' ||
          !show.headerMobile
        "
        :style="
          show.blur && show.headerMobile
            ? 'top:calc(0px - var(--header-main-height))'
            : ''
        "
      >
        <div
          class="left-hand"
          :class="[
            { headliner: show.drawer },
            { opacityDescktoop: show.drawer },
          ]"
        >
          <div class="sided-wrapper-bars-wrapper">
            <div
              class="btn-primary sided-wrapper-bars-wrapper-in"
              @click="show.drawer = !show.drawer"
            >
              <div class="grip-lines">
                <div></div>
                <div></div>
              </div>
              <div class="section">
                {{
                  (route.name?.substring(route.name.length - 11) ===
                    "MainWrapper" &&
                    active === undefined) ||
                  route.name?.substring(route.name.length - 11) ===
                    "FeedWrapper" ||
                  route.name?.substring(route.name.length - 11) !==
                    "MainWrapper"
                    ? $t("main.sections")
                    : getByUnique(active, categories, "slug")?.[
                        `name_${i18n.global.locale.value}`
                      ]
                }}
              </div>
            </div>
            <div
              class="burger-mobile"
              @click="show.drawer = !show.drawer"
              :class="show.drawer ? 'active' : ''"
            ></div>
          </div>
        </div>
        <div class="right-hand">
          <div
            class="btn-primary sided-wrapper-bars-wrapper-in"
            style="pointer-events: none; opacity: 0"
          >
            <div class="grip-lines">
              <div></div>
              <div></div>
            </div>
            <div class="btn-grop-top"></div>
            <div class="section">
              {{
                (route.name?.substr(route.name.length - 11) === "MainWrapper" &&
                  active === undefined) ||
                route.name?.substr(route.name.length - 11) === "FeedWrapper" ||
                route.name?.substr(route.name.length - 11) !== "MainWrapper"
                  ? $t("main.sections")
                  : getByUnique(active, categories, "slug")?.[
                      `name_${i18n.global.locale.value}`
                    ]
              }}
            </div>
          </div>
          <div class="btn-group">
            <transition name="fade">
              <router-link
                v-if="
                  route.name?.substr(route.name.length - 11) !==
                    'SearchQuery' &&
                  route.name?.substr(route.name.length - 6) !== 'Search'
                "
                :to="
                  $i18nRoute({ name: 'Search', params: { category: active } })
                "
                class="btn-primary top-btn"
                title="Search"
              >
                <i class="fal fa-search"></i>
              </router-link>
            </transition>
            <router-link
              :to="
                $i18nRoute({
                  name: access
                    ? 'PreferredLang_StaffDetail'
                    : 'LogIn_Authorization',
                })
              "
              class="btn-primary top-btn top-btn-text"
              v-on:mouseover="show.socials = false"
              v-on:mouseleave="show.socials = true"
            >
              <i class="fal fa-pen-alt icon"></i>
              <span class="text">{{ $t("header.new_news") }}</span>
            </router-link>
            <router-link
              :to="
                $i18nRoute({ name: 'LiveStream', params: { category: 'feed' } })
              "
              class="btn-primary top-btn top-btn-text"
              v-on:mouseover="show.socials = false"
              v-on:mouseleave="show.socials = true"
            >
              <i class="far fa-signal-stream icon" style="color: #b01030"></i>
              <span class="text">{{ $t("main.live_stream") }}</span>
            </router-link>

            <button
              v-if="!darkCats.includes(active)"
              @click="handleTheme"
              class="btn-primary top-btn"
            >
              <i v-if="theme == 'light'" class="fas fa-moon"></i>
              <i v-else class="fas fa-sun"></i>
            </button>
            <transition name="fade">
              <div v-show="show.socials" class="soc-net-menu">
                <a
                  href="https://twitter.com/zamon_uz"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <i class="fab fa-twitter"></i>
                </a>
                <a
                  href="https://www.facebook.com/zamontv/"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <i class="fab fa-facebook-f"></i>
                </a>
                <a
                  href="https://t.me/zamonuz"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <i class="fab fa-telegram-plane"></i>
                </a>
                <a
                  href="https://www.instagram.com/zamon.uz/?igshid=7pq6rzpavqgb"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <i class="fab fa-instagram"></i>
                </a>
              </div>
            </transition>
          </div>
          <div
            style="
              display: flex;
              align-items: center;
              height: 100%;
              margin-left: auto;
            "
          >
            <transition name="fade">
              <router-link
                :to="
                  $i18nRoute({ name: 'Search', params: { category: active } })
                "
                class="search-mobile-close"
                v-show="!show.drawer"
                @click="show.drawer = false"
                v-if="
                  route.name?.substr(route.name.length - 11) !==
                    'SearchQuery' &&
                  route.name?.substr(route.name.length - 6) !== 'Search'
                "
                title="Search"
              >
                <i class="fal fa-search"></i>
              </router-link>
            </transition>
            <div class="registr-block">
              <router-link
                :to="$i18nRoute({ name: 'StaffPage' })"
                class="btn-primary"
              >
                {{ $t("staff_page.journalists") }}
              </router-link>
              <router-link
                :to="
                  $i18nRoute({
                    name: access
                      ? 'PreferredLang_StaffDetail'
                      : 'LogIn_Authorization',
                  })
                "
                class="blue-btn"
              >
                {{ $t("header.auth") }}
              </router-link>
            </div>
            <div
              class="lang-holder btn-primary"
              ref="language"
              @click.stop="showLang"
            >
              <i
                style="
                  font-size: 120%;
                  margin-right: 5px;
                  transform: translateY(10%);
                "
                class="fas fa-globe"
              ></i>
              <span style="text-transform: capitalize">
                {{ $t(`main.short_lang.${i18n.global.locale.value}`) }}</span
              >
              <i style="padding-left: 4px" class="fas fa-chevron-down"></i>
              <div
                class="choices"
                :style="{ height: show.lang ? '160px' : '0px' }"
              >
                <template v-for="(lang, index) in SUPPORT_LOCALES" :key="index">
                  <div
                    v-if="lang !== i18n.global.locale.value"
                    class="choice-lang"
                    @click="switchLanguage(lang)"
                  >
                    {{ $t(`main.full_lang.${lang}`) }}
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </header>
  <transition name="fromright" appear>
    <button
      class="btn-in-top"
      title="Scroll to top"
      v-show="show.blur"
      @click="$scrollToTop('smooth')"
    >
      <i class="fad fa-chevron-up"></i>
    </button>
  </transition>
  <div class="drawer-holder">
    <transition name="fromleft" appear>
      <div v-show="show.drawer" class="drawer-cont">
        <router-link
          :to="
            $i18nRoute({
              name: 'FeedWrapper',
            })
          "
          class="headliner logo-img"
          v-if="!show.wrapper"
        >
          <img src="@/assets/zamonuz.png" alt="Zamon" />
        </router-link>
        <div v-else class="headliner"></div>
        <div>
          <div class="headliner-spacer">
            <div>
              <router-link
                :to="$i18nRoute({ name: 'FeedWrapper' })"
                class="mobile-logo"
              >
                <img src="@/assets/zamonuz.png" alt="Zamon" />
              </router-link>
            </div>
            <button
              @click="handleTheme"
              style="pointer-events: all; cursor: pointer"
              class="btn-primary mobile-theme"
            >
              <i v-if="theme == 'light'" class="fas fa-moon"></i>
              <i v-else class="fas fa-sun"></i>
            </button>
          </div>
        </div>
        <div class="mobile-lang-holder" v-if="route.params.slug === undefined">
          <div
            @click="switchLanguage(lang)"
            :class="{ active: i18n.global.locale._value === lang }"
            v-for="(lang, index) in SUPPORT_LOCALES"
            :key="index"
          >
            {{ $t(`main.short_lang.${lang}`) }}
          </div>
        </div>
        <div class="registr-block">
          <router-link
            :to="
              $i18nRoute({ name: 'LiveStream', params: { category: 'feed' } })
            "
            class="btn-primary"
          >
            <i class="far fa-signal-stream icon" style="color: #b01030"></i>
            <span class="text">{{ $t("main.live_stream") }}</span>
          </router-link>
          <router-link
            :to="
              $i18nRoute({
                name: access ? 'StaffDetail' : 'LogIn_Authorization',
              })
            "
            class="btn-primary"
          >
            <i class="fas fa-pencil icon"></i>
            <span class="text">{{ $t("header.new_news") }}</span>
          </router-link>
          <router-link
            :to="$i18nRoute({ name: 'StaffPage' })"
            class="menu-btn btn-primary"
          >
            {{ $t("staff_page.journalists") }}
          </router-link>
          <router-link
            :to="
              $i18nRoute({
                name: access
                  ? 'PreferredLang_StaffDetail'
                  : 'LogIn_Authorization',
              })
            "
            class="btn-primary blue"
          >
            {{ $t("header.auth") }}
          </router-link>
          <a href="https://t.me/zamon_broadcaster_bot" class="ca-btn">
            {{ $t("header.appeal") }}
          </a>
        </div>

        <div class="spacer-mobile-menu"></div>
        <nav class="nav-holder">
          <div
            class="back-button"
            v-if="
              hasBack() &&
              route.name?.substring(route.name.length - 10) == 'NewsDetail'
            "
            @click="$router.back()"
          >
            <i class="fas fa-chevron-left back-icon"></i>
            <div class="back-text">{{ $t("main.return") }}</div>
          </div>
          <router-link
            :to="
              $i18nRoute({
                name: 'FeedWrapper',
              })
            "
            v-if="
              !show.wrapper || active !== 'feed' || route.name !== 'MainWrapper'
            "
            >{{ $t("main.main") }}</router-link
          >
          <router-link
            :to="
              $i18nRoute({
                name: 'FeedWrapper',
              })
            "
            v-else
            @click.prevent="navToMainDrawer"
            >{{ $t("main.main") }}</router-link
          >
          <router-link
            v-for="(item, index) in categories"
            :key="index"
            :class="
              activeArticle?.sub_category?.category?.slug === item?.slug &&
              route.name?.substring(route.name.length - 10) === 'NewsDetail'
                ? 'active-link-news'
                : ''
            "
            :to="
              $i18nRoute({
                name: 'MainWrapper',
                params: { category: item.slug },
              })
            "
            >{{ item[`name_${i18n.global.locale.value}`] }}
            <!-- {{route.name }} -->
          </router-link>
        </nav>
        <div class="spacer-mobile-menu"></div>
        <div class="soc-net-holder">
          <a
            href="https://twitter.com/zamon_uz"
            rel="noopener noreferrer"
            target="_blank"
          >
            <i class="fab fa-twitter"></i>
          </a>
          <a
            href="https://www.facebook.com/zamontv/"
            rel="noopener noreferrer"
            target="_blank"
          >
            <i class="fab fa-facebook-f"></i>
          </a>
          <a
            href="https://t.me/zamonuz"
            rel="noopener noreferrer"
            target="_blank"
          >
            <i class="fab fa-telegram-plane"></i>
          </a>
          <a
            href="https://www.instagram.com/zamon.uz/?igshid=7pq6rzpavqgb"
            rel="noopener noreferrer"
            target="_blank"
          >
            <i class="fab fa-instagram"></i>
          </a>
        </div>
      </div>
    </transition>
    <div
      v-if="show.drawer && slug === undefined"
      style="flex: 1 0 0; cursor: crosshair; pointer-events: all"
      @click="show.drawer = false"
    ></div>
  </div>
  <!-- <SiteTest /> -->
</template>
<script>
import {
  computed,
  onBeforeUnmount,
  onMounted,
  reactive,
  ref,
  watch,
} from "vue";
import { useStore } from "vuex";
import { useLanguage } from "@/utils/language";
import { useRoute } from "vue-router";
import { SUPPORT_LOCALES } from "../i18n";
import { useOrm } from "@/utils/orm";
import { useNavigation } from "@/utils/navigation";
import { darkCats } from "@/utils/constants";

// import SiteTest from "./SiteTest.vue";

export default {
  // components: {
  //   SiteTest,
  // },
  setup() {
    const store = useStore();
    const show = reactive({
      wrapper: true,
      blur: false,
      drawer: false,
      headerMobile: true,
      socials: true,
      lang: false,
    });
    let lastScroll = 0;
    const language = ref(null);
    const showLang = () => {
      show.lang = !show.lang;
    };

    const closeLang = (e) => {
      if (language.value && !language.value.contains(e.target)) {
        show.lang = false;
      }
    };

    const checkWidth = () => {
      if (typeof window !== "undefined") {
        if (window.innerWidth >= 992) {
          show.headerMobile = true;
        } else {
          show.headerMobile = false;
        }
      }
    };

    var resizeTimeout;
    function resizeThrottler() {
      if (!resizeTimeout) {
        resizeTimeout = setTimeout(function () {
          resizeTimeout = null;
          checkWidth();

          // The checkWidth will execute at a rate of 15fps
        }, 66);
      }
    }
    let mainInterval;
    onMounted(() => {
      if (typeof window !== "undefined") {
        window.addEventListener("resize", resizeThrottler, false);
        resizeThrottler();
        document.addEventListener("click", closeLang, true);
      }
    });
    onBeforeUnmount(() => {
      if (typeof window !== "undefined") {
        if (mainInterval) clearInterval(mainInterval);
        window.removeEventListener("resize", resizeThrottler);
        document.removeEventListener("click", closeLang);
      }
    });

    store.dispatch("weatherCurrency");

    const route = useRoute();

    const showFunc = async () => {
      if (window.innerWidth >= 992) {
        show.wrapper = route.params.slug === undefined;
        show.drawer = route.params.slug !== undefined;
        show.headerMobile = true;
      } else {
        show.drawer = false;
        show.wrapper = true;
        show.headerMobile = false;
      }
    };

    watch(() => route.params.slug, showFunc);

    watch(() => route.params.category, showFunc);

    watch(() => route.name, showFunc);

    const navToMainDrawer = () => {
      window?.scrollTo({ top: 0, behavior: "smooth" });
      show.drawer = !show.drawer;
    };

    const handleScroll = () => {
      show.blur = window.pageYOffset >= 10;
      if (window.pageYOffset < lastScroll || window.pageYOffset <= 10) {
        // console.log("go top");
        show.blur = false;
      } else {
        // console.log("go down");
        show.blur = true;
      }
      lastScroll = window.pageYOffset;
    };

    onMounted(() => {
      document.addEventListener("scroll", handleScroll);
      showFunc();
    });

    onBeforeUnmount(() => {
      document.removeEventListener("scroll", handleScroll);
    });

    const handleTheme = () => store.commit("handleTheme");

    return {
      categories: computed(() => store.getters.categories),
      active: computed(() => route.params.category),
      route: computed(() => route),
      weather: computed(() => store.getters.weather),
      currency: computed(() => store.getters.currency),
      SUPPORT_LOCALES,
      show,
      navToMainDrawer,
      slug: computed(() => route.params.slug),
      ...useOrm(),
      ...useLanguage(),
      showLang,
      language,
      handleTheme,
      theme: computed(() => store.getters.theme),
      ...useNavigation(),
      activeArticle: computed(() => store.getters.activeArticle),
      access: computed(() => store.getters.access),
      darkCats,
    };
  },
};
</script>

<style lang="scss" scoped>
html {
  --bg-overlay: 18, 18, 18;
  &[data-theme="dark"] {
    --bg-overlay: 240, 240, 240;
  }
  .header {
    --color-btn: #dfdfdf;
  }
  &[data-theme="dark"] {
    .header {
      --color-btn: #626262;
    }
  }
  .drawer-holder {
    --color-btn: #dfdfdf;
    --color-menu: rgba(var(--primary-bg), 0.8);
  }
  &[data-theme="dark"] {
    .drawer-holder {
      --color-btn: #626262;
      --color-menu: #ebebeb;
    }
  }
}
.btn-primary {
  color: var(--color-btn);
  background: var(--foreground-color);
}
.header {
  --btn-size: calc(max(28px, 2vw));
  --mobile-size-btn: calc(min(38px, 8vw));
  --header-wrapper-width: 90%;
  // --color-btn: #626262;
}
.height-enter-active,
.height-leave-active {
  transition: all 0.4s ease;
}

.height-enter-from,
.height-leave-to {
  height: 0 !important;
}

.width-enter-active,
.width-leave-active {
  transition: all 0.8s ease;
}

.width-enter-from,
.width-leave-to {
  width: 0 !important;
  opacity: 0;
}

.fromtophead-enter-active,
.fromtophead-leave-active {
  transition: all 0.6s ease !important;
  transform: translate(-50%, 0);
}

.fromtophead-enter-from,
.fromtophead-leave-to {
  opacity: 0;
  transform: translate(-50%, -100%) !important;
}

@supports not ((-webkit-backdrop-filter: none) or (backdrop-filter: none)) {
  .mobile-blur {
    background-color: rgba(var(--primary-bg), 0.6);
  }
}

.mobile-blur {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: calc(var(--header-main-height) + 52px);
  background: linear-gradient(
    180deg,
    rgba(var(--primary-bg), 0.6) 0%,
    rgba(var(--primary-bg), 0.18) 100%
  );
  // backdrop-filter: blur(8px);
  // border-bottom: 1px solid rgba(var(--primary-bg), 0.6);
  z-index: 30;
}

// .inverse {
//   // mix-blend-mode: difference;
// }
.registr-block {
  pointer-events: all;
  margin-right: 3vw;
  font-size: calc(max(14px, 0.9vw));
  display: flex;

  .btn-primary {
    font-size: calc(max(14px, 0.9vw));
    display: block;
    line-height: calc(max(28px, 2vw));
    height: calc(max(28px, 2vw));
    margin-right: calc(max(10px, 0.83vw));
    padding: 0 calc(min(22px, 1vw));
    @media screen and (max-width: 992px) {
      height: auto;
    }
  }

  .blue-btn {
    background: #114794;
    border-radius: 4px;
    padding: 0 calc(min(22px, 1vw));
    line-height: calc(max(28px, 2vw));
    height: calc(max(28px, 2vw));
    color: #fff;
  }
}
.ca-btn {
  font-size: 22px;
  padding: 1.5rem;
  width: 96%;
  border-radius: 4px;
  background: var(--primary-font-color);
  color: var(--color-btn);
  @media screen and (max-width: 992px) {
    height: auto;
  }
}
.btn-group {
  display: flex;
  align-items: center;
  height: 100%;
  overflow: hidden;
}
.btn-in-top {
  cursor: pointer;
  position: fixed;
  bottom: 2em;
  right: 1.8em;
  width: 3.8em;
  height: 3.8em;
  border-radius: 100%;
  background: var(--background-color);
  z-index: 30;
  box-shadow: rgba(var(--secondary-bg), 0.2) 0 1px 12px 6px;

  i {
    color: var(--primary-font-color);
    font-size: 2em;
  }
}
.bottom-logo {
  // width: 146px;
  width: calc(max(106px, 8vw));
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 5%;
  padding: 0.1vh 0;
  img {
    width: 100%;
    height: 100%;
  }
}
.soc-net-menu {
  display: flex;

  a {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: calc(max(16px, 1.2vw));
    height: var(--btn-size);
    margin-left: 1.2vw;
    pointer-events: all;
  }
}
.wrapper {
  height: auto;
  position: fixed;
  z-index: 30;
  top: 0;
  left: 50%;
  transform: translate(-50%, 0);
  transition: all 0.4s ease;
  width: 100%;
  background: linear-gradient(
    180deg,
    rgba(var(--primary-bg), 0.8) 0%,
    rgba(var(--primary-bg), 0.8) 100%
  );
  // background: var(--background-color);
  box-shadow: 0 0 20px 10px rgba(0, 0, 0, 0.2);

  @media screen and (max-width: 375px) {
    height: 48px;
  }

  &-top-container {
    width: 105%;
    height: var(--header-main-height);
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;

    .nav-item {
      display: flex;
      // justify-content: center;
      align-items: center;
      // font-weight: bold;
      padding: 2px calc(max(5px, 0.5vw));

      border-radius: 4px;
      font-family: Roboto;
      font-size: calc(max(14px, 0.95vw));
      // font-size: 1.1em;
      transition: all 0.2s;

      div {
        padding-left: 8px;
      }

      .main {
        position: relative;
        padding: 0 20px;
        // mix-blend-mode: difference;
        // font: 900 calc(min(55px, 3vw)) cookie, cursive;
        font-size: calc(min(55px, 3vw));
        font-weight: 900;
        text-transform: uppercase;
        letter-spacing: 0.05em;
        font-family: "Playfair Display", sans-serif;
        pointer-events: none;

        img {
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: -20px;
          margin: 0 20px;
          object-fit: contain;
          background-color: transparent;
          pointer-events: none;
        }

        &::first-letter {
          font-size: 1.15em;
        }
      }
    }
  }
  .sub-cat-container {
    max-width: var(--header-wrapper-width);
    margin: 0 auto;
    height: auto;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .line {
    width: 100%;
    height: 1px;
    background-color: var(--foreground-color);
    left: 50%;
    bottom: 0;
    position: absolute;
    transform: translateX(-50%);

    &.middle {
      opacity: 0.5;
    }

    &.bottom {
      opacity: 1;
    }
  }
}
.logo-img {
  width: 100%;
  padding: 0 1em;
  img {
    width: 100%;
    height: auto;
  }
}

.sub-cat {
  &-container {
    width: 100%;
    height: 30px;
    display: flex;
    position: relative;
    align-items: flex-start;
    justify-content: center;
    overflow: hidden;
    transition: height 0.5s ease;
    font-family: Roboto;
    font-size: calc(min(2.325em, 1.125vw));
  }
  &-item:last-of-type {
    margin-right: 0;
  }
  &-item {
    padding: 10px 0.6vw;
    margin-right: 1.5vw;
    height: 100%;
    text-align: center;
    text-transform: capitalize;
    transition: all 0.2s ease;
    cursor: pointer;
    display: flex;
    align-items: center;

    &.router-link-exact-active {
      // text-decoration: underline;
      font-weight: 500;
      border-bottom: 2px solid var(--foreground-color);
      // transform: translateY(2px);
    }

    &:hover {
      opacity: 1;
    }
  }
}

.top-btn {
  height: var(--btn-size);
  width: var(--btn-size);
  min-width: var(--btn-size);
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 0.5vw;
  pointer-events: all;
  padding: 0.3rem;
}

.desktop.left-hand {
  display: flex;
  @media screen and (max-width: 992px) {
    display: none;
  }
}

.left-hand {
  // display: none;
  width: var(--header-wrapper-width);
  height: var(--header-main-height);
  top: 0;
  left: 50%;
  // display: flex;
  transform: translateX(-50%);
  position: fixed;
  transition: all 0.4s;
  z-index: 30;
  @media screen and (max-width: 992px) {
    display: block;
  }

  &.headliner {
    width: 100%;

    .sided-wrapper-bars-wrapper {
      margin-left: calc(var(--drawer-width) / 2);
      transform: translateX(-50%);

      &-in {
        .grip-lines {
          height: clamp(15px, 40%, 20px);

          div {
            transform-origin: left;
            height: 2px;

            &:first-child {
              transform: rotate(45deg);
            }

            &:last-child {
              transform: rotate(-45deg);
            }
          }
        }
      }
    }
  }
  .active.burger-mobile::before {
    transform: translateY(0) rotate(45deg);
  }
  .active.burger-mobile::after {
    transform: translateY(0) rotate(-45deg);
  }
  .burger-mobile {
    display: none;
    align-items: center;
    justify-content: center;
    outline: none;
    height: var(--mobile-size-btn);
    width: calc(var(--mobile-size-btn) + 2vw);
    border: 0px;
    padding: 0px;
    background: transparent;
    transition: all 250ms ease-out;
    cursor: pointer;
    background: var(--foreground-color);
    border-radius: 4px;
    &::before,
    &::after {
      content: "";
      width: calc(var(--mobile-size-btn));
      height: 2.5px;
      position: absolute;
      background: var(--color-btn);
      transition: all 250ms ease-out;
      will-change: transform;
      border-radius: 25%;
    }
    &::before {
      transform: translateY(-5px);
    }
    &::after {
      transform: translateY(5px);
    }
  }
}

.sided-wrapper {
  width: 100%;
  height: var(--header-main-height);
  position: fixed;
  z-index: 30;
  top: 0;
  left: 50%;
  transform: translate(-50%, 0);
  display: flex;
  justify-content: space-between;
  align-items: center;
  pointer-events: none;
  transition: all 0.4s ease;
  .left-hand {
    width: var(--header-wrapper-width);
    height: 100%;
    top: 0;
    left: 50%;
    display: flex;
    transform: translateX(-50%);
    position: absolute;
    transition: all 0.4s;

    &.headliner {
      width: 100%;

      .sided-wrapper-bars-wrapper {
        margin-left: calc(var(--drawer-width) / 2);
        transform: translateX(-50%);
        &-in {
          .grip-lines {
            height: clamp(15px, 40%, 20px);

            div {
              transform-origin: left;
              height: 2px;

              &:first-child {
                transform: rotate(45deg);
              }

              &:last-child {
                transform: rotate(-45deg);
              }
            }
          }
        }
      }
    }
  }

  .right-hand {
    width: 90%;
    height: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    top: 0;
    right: 50%;
    transform: translateX(50%);
    position: absolute;
    z-index: 33;
  }

  &-bars-wrapper {
    position: relative;
    height: 100%;
    display: flex;
    align-items: center;
    pointer-events: all;
    transition: all 0.4s;

    &-in {
      padding: 0 10px;
      display: flex;
      height: var(--btn-size);
      font-size: 18px;
      align-items: center;
      letter-spacing: 0.5px;

      .grip-lines {
        height: 9px;
        // height: calc(max(10px, 1vw));
        width: calc(max(18px, 1vw));
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        transition: all 0.4s;

        div {
          width: 100%;
          height: 2px;
          background-color: var(--color-btn);
          border-radius: 1px;
          transition: inherit;
        }
      }

      .section {
        text-transform: capitalize;
        // font-weight: bold;
        // font-size: 0.9em;
        font-size: calc(max(16px, 1.2vw));
        display: flex;
        align-items: center;
        padding: 0 2px 0 5px;
      }

      .sub-section {
        text-transform: uppercase;
        font-weight: bold;
        font-size: 0.9em;
        opacity: 0.6;
        overflow: hidden;
      }

      &:hover {
        .grip-lines {
          div {
            background-color: var(--color-btn);
          }
        }
      }
    }
  }

  .top-btn-text {
    .text {
      white-space: nowrap;
      width: 0;
      overflow: hidden;
    }
    .icon {
      width: var(--btn-size);
      display: flex;
      justify-content: center;
      align-items: center;
    }
    &:hover {
      width: 100%;
      .text {
        width: 100%;
      }
      @media screen and (max-width: 1200px) {
        width: 0;
        .text {
          width: 0%;
        }
      }
    }
  }

  .search-mobile {
    font-size: calc(min(20px, 5vw));

    pointer-events: all;
    width: var(--btn-size);
    padding: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    height: var(--btn-size);
    // margin-left: 20px;
  }

  .search-mobile-close {
    font-size: calc(min(20px, 5vw));
    pointer-events: all;
    width: var(--mobile-size-btn);
    height: var(--mobile-size-btn);
    padding: 0;
    justify-content: center;
    align-items: center;
    margin-left: 20px;
    display: none;
    background: var(--foreground-color);
    color: var(--color-btn);
    border-radius: 4px;
  }

  .avatar-wrapper {
    height: 100%;
    display: flex;
    align-items: center;
    cursor: pointer;
    pointer-events: all;

    .profile {
      width: 36px;
      height: 36px;
      border-radius: 100%;
      overflow: hidden;
    }
  }

  .lang-holder {
    padding: 0 0.6rem;
    // padding-left: 30px;
    height: 100%;
    cursor: pointer;
    pointer-events: all;
    position: relative;
    display: flex;
    align-items: center;
    font-size: calc(max(14px, 0.9vw));
    line-height: calc(max(28px, 2vw));
    height: calc(max(28px, 2vw));
    &:focus,
    &:active {
      .choices {
        height: 160px;
      }
    }

    .choices {
      position: absolute;
      top: 100%;
      right: 0;
      height: 0;
      overflow: hidden;
      cursor: default;
      background-color: var(--foreground-color);
      border-radius: 8px 0 8px 8px;
      pointer-events: none;
      transition: all 0.4s ease;
      text-shadow: none;

      .choice-lang {
        color: var(--secondary-font-color);
        width: 140px;
        height: 48px;
        display: flex;
        align-items: center;
        padding-left: 16px;
        cursor: pointer;
        pointer-events: all;
        transition: all 0.2s;

        &:hover {
          background-color: var(--background-color);
          color: var(--primary-font-color);
        }

        &:first-child {
          margin-top: 8px;
        }

        &:last-child {
          margin-bottom: 8px;
        }
      }
    }
  }
}

.drawer-holder {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  z-index: 30;
  pointer-events: none;
}

.drawer-cont {
  width: var(--drawer-width);
  border-right: 1px solid rgba(var(--primary-bg), 0.1);
  height: 100vh;
  left: 0;
  top: 0;
  overflow-y: auto;
  display: flex;
  backdrop-filter: blur(8px);
  background-color: rgba(var(--secondary-bg), 0.1);
  flex-direction: column;
  pointer-events: all;
  text-align: center;
  border-right: 2px solid rgba(var(--secondary-bg), 0.65);
  @media screen and (max-width: 992px) {
    background-color: rgba(18, 58, 116, 0.75);
    backdrop-filter: blur(55px);
  }
  .registr-block {
    display: none;
  }

  &::-webkit-scrollbar {
    width: 0.375rem;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    background: transparent;
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: hsla(0, 0%, 30%, 0.7);
    border-radius: 8px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: hsla(0, 0%, 50%, 0.8);
  }

  .headliner {
    height: calc(max(106px, 7.5vw));
    display: flex;
    justify-content: center;
    align-items: center;
    font: 900 2.25em cookie, cursive;
    text-transform: capitalize;
    letter-spacing: 0.05em;
    font-family: "Playfair Display SC", serif;
    border-bottom: 2px solid rgba(var(--secondary-bg), 0.65);

    i {
      font-size: 0.8em;
      margin-right: 0.4rem;
      font-weight: normal;
    }

    &::first-letter {
      font-size: 1.15em;
    }
    .drawer-btn {
      padding: 0 10px;
      display: flex;
      height: calc(max(28px, 2vw));
      font-size: 18px;
      align-items: center;
      font-family: Roboto;
      font-weight: normal;
      font-size: calc(max(16px, 1.2vw));
      color: var(--color-btn);
      letter-spacing: 0;
      .section {
        padding: 0 2px 0 5px;
      }

      .grip-lines {
        height: 14px;
        // height: calc(max(10px, 1vw));
        width: calc(max(18px, 1vw));
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        transition: all 0.4s;
        div {
          width: 100%;
          height: 2px;
          background-color: var(--color-btn);
          border-radius: 1px;
          transition: inherit;
          transform-origin: left;

          &:first-child {
            transform: rotate(45deg);
          }

          &:last-child {
            transform: rotate(-45deg);
          }
        }
      }
    }
  }

  .nav-holder {
    display: flex;
    flex-direction: column;
    font-family: Open Sans;
    font-size: 1.45em;
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 4px;
    }
    &::-webkit-scrollbar-track {
      backdrop-filter: blur(8px);
      background-color: rgba(var(--secondary-bg), 0.1);
    }
    &::-webkit-scrollbar-thumb {
      background: rgba(var(--secondary-bg), 0.4);
      border-radius: 10px;
    }
    .router-link-exact-active {
      font-weight: 600;
    }
    .active-link-news {
      font-weight: 600;
    }

    a {
      padding: 0.9rem 0;
      padding-left: 0.9em;
      position: relative;
      color: var(--color-menu);
      transition: all 0.2s ease;
      text-transform: capitalize;
      display: block;

      &:hover {
        backdrop-filter: blur(8px);
        background-color: rgba(var(--primary-bg), 0.1);
        color: var(--primary-font-color);
      }
      .nav-indicator {
        position: absolute;
        height: 100%;
        width: 4px;
        top: 0;
        left: 0;
        background-color: #fff;
      }
    }
  }
  .back-button {
    display: flex;
    justify-content: center;
    align-items: center;
    // height: 65px;
    background: rgba(var(--secondary-bg), 0.1);
    backdrop-filter: blur(15px);
    cursor: pointer;
    transition: all 0.2s ease-in;
    .back-text {
      text-transform: capitalize;
      font-size: 0.7em;
      color: rgba(var(--secondary-bg), 0.95);
      padding: 1em 0;
    }
    &:hover {
      background: rgba(var(--secondary-bg), 0.7);
      .back-text {
        color: rgba(var(--primary-bg), 0.95);
      }
    }
    .back-icon {
      margin-right: 0.5em;
      font-size: 1.4em;
      color: rgba(var(--primary-bg), 0.7);
      font-weight: 200;
    }
  }

  .soc-net-holder {
    // margin-top: auto;
    margin-bottom: 20px;
    width: 80%;
    margin: 0 auto;
    display: none;
    justify-content: space-evenly;
    align-items: center;
    font-size: 3em;
    padding-bottom: 2rem;
  }

  .mobile-lang-holder {
    font-family: Roboto;
    font-weight: bold;
    font-size: 20px;
    line-height: 23px;
    display: none;
    justify-content: center;
    align-items: center;
    font-size: calc(max(18px, 0.8vw));
    color: rgba(var(--secondary-bg), 0.7);
    text-transform: capitalize;
    cursor: pointer;
    margin-top: 1em;
    .active {
      font-weight: bold;
      color: rgb(255, 255, 255);
    }
    div {
      margin: 2rem 1.5rem;
    }
  }
}

.mobile-link-btn {
  display: none;
}
.headliner-spacer {
  display: none;
  align-items: center;
  width: 90%;
  margin: 0 auto;
  height: var(--header-main-height);
  position: relative;
  .btn-primary {
    pointer-events: all;
    cursor: pointer;
  }
  .mobile-theme {
    width: calc(min(38px, 8vw) + 10px);
    height: calc(min(38px, 8vw));
    font-size: 1.9em;
    margin-left: auto;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .mobile-logo {
    // width: 33%;
    height: 75%;
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
      background: transparent;
    }
  }
}
.opacityDescktoop {
  opacity: 0;
}

@media screen and (max-width: 1366px) {
  .drawer-cont {
    height: calc(100% / 0.7);
  }
}
@media screen and (max-width: 1200px) {
  .sub-cat-container {
    .bottom-logo {
      margin-right: 2%;
    }
  }
  .wrapper-top-container {
    width: 100%;
  }
  .information-block {
    display: none;
  }
}

@media screen and (max-width: 992px) {
  .opacityDescktoop {
    opacity: 1;
  }
  .wrapper-top-container {
    width: 100%;
  }
  .spacer-mobile-menu {
    width: 100%;
    background: #ebebeb;
    height: 1px;
    margin: 1rem 0;
  }

  .mobile-link-btn {
    width: 90%;
    margin: 1rem auto 2rem;
    display: flex;
    justify-content: space-around;
    .btn-primary {
      // color: #626262;
      font-size: 1.4em;
      // width: 257px;
      width: calc(max(130px, 33.5vw));
      height: 70px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .text {
      margin-left: 1rem;
    }
    .icon {
      font-size: 1.8em;
    }
  }

  .btn-group {
    display: none;
  }

  .mobile-blur {
    height: var(--header-main-height);
  }

  .drawer-cont {
    height: 100%;
  }

  .wrapper {
    .wrapper-top-container {
      .nav-item {
        display: none;
        padding: 0;

        &.headline {
          pointer-events: all;
          display: block;
        }

        .main {
          font-size: 3.5em;
          line-height: 1.4em;

          &::first-letter {
            font-size: 4.15rem;
          }
        }
      }

      .line.middle {
        display: none;
      }
    }

    .sub-cat-container {
      display: none;
    }
  }

  .sided-wrapper {
    z-index: 33;
    .sub-section {
      display: none;
    }
  }

  .drawer-cont {
    .registr-block {
      display: flex;
      justify-content: space-around;
      flex-wrap: wrap;
      width: 80%;

      margin: 0.8em auto 0.5em;
      .btn-primary {
        margin: 1rem 0;
        flex: 0 0 46%;
        text-align: center;
        max-width: 100%;
        font-size: 22px;
        padding: 1.5rem 0;
      }
      .text {
        display: inline-block;
        line-height: 1;
      }
      .icon {
        padding: 0 3%;
        line-height: 1;
        font-size: 25px;
      }
      .blue {
        background: #114794;
        color: #fff;
      }
      @media screen and (max-width: 767px) {
        width: 90%;
        .btn-primary {
          font-size: 14px;
          padding: 0.5rem 0;
        }
        .ca-btn {
          font-size: 14px;
          padding: 0.5rem 0;
        }

        .icon {
          font-size: 20px;
        }
      }
    }

    .nav-holder {
      width: 90%;
      margin: 0 auto;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      padding: 0;
      font-size: 1.75em;
      font-weight: normal;
      text-align: center;
      color: var(--color-btn);
      .back-button {
        display: none;
      }
      a {
        font-size: 0.9em;
        line-height: 1.4em;
        padding: 0;
        position: relative;
        flex: 0 0 25%;
        margin: 1rem 0;

        &.router-link-exact-active {
          color: white;
          // padding-left: 2em;
          font-weight: 600;

          &::after {
            transform: translateX(0);
          }
        }
      }
    }

    .mobile-lang-holder,
    .soc-net-holder {
      display: flex;
    }
    .soc-net-holder {
      margin-top: 1rem;
    }
  }
  .registr-block {
    display: none;
  }
  .soc-net-menu {
    display: none;
  }
  .mobile-blur {
    height: var(--header-main-height);
  }

  .wrapper {
    position: fixed;
    pointer-events: none;
    .wrapper-top-container {
      .nav-item {
        &.headline {
          display: block;
        }

        .main {
          font-size: calc(max(35px, 5vw));
          line-height: 1em;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }
  }

  .sided-wrapper {
    position: fixed;
    z-index: 36;

    .search-mobile {
      display: none;
    }

    .search-mobile-close {
      display: flex;
    }

    .left-hand {
      &.headliner {
        width: var(--header-wrapper-width);

        .sided-wrapper-bars-wrapper {
          margin-left: 0;
          transform: unset;
        }
      }
    }

    .lang-holder,
    .sided-wrapper-bars-wrapper-in {
      display: none;
    }

    .burger-mobile {
      display: flex;
    }
  }

  .drawer-cont {
    width: 100%;

    .headliner {
      display: none;
    }
    .headliner-spacer {
      display: flex;
    }
  }
}
@media screen and (max-width: 767px) {
  .drawer-cont {
    .nav-holder {
      font-size: 1.425em;
      a {
        flex: 0 0 33%;
      }
    }
  }
  .registr-block {
    font-weight: 500;
    font-size: 1.3em !important;
    line-height: 26px;
    .blue-btn {
      padding: 10px 50px !important;
    }
    .transparent {
      margin-right: 1.3em !important;
    }
  }
  .mobile-link-btn {
    pointer-events: all;
    .btn-primary {
      width: 160px;
      height: 37px;
    }
    .icon {
      font-size: 1em;
      line-height: 19px;
    }
    .text {
      font-size: 0.8em;
      line-height: 19px;
      margin-left: 3%;
    }
  }
  .headliner-spacer {
    .mobile-logo {
      height: 70%;
    }
  }
}

@media screen and (max-width: 374px) {
  .drawer-cont {
    .nav-holder {
      font-size: 1.1em;
    }
  }
  .mobile-link-btn {
    pointer-events: all;
    .btn-primary {
      width: 130px;
      height: 37px;
    }
    .icon {
      font-size: 0.9em;
      line-height: 19px;
    }
    .text {
      font-size: 0.6em;
      line-height: 19px;
      margin-left: 3%;
    }
  }
  .mobile-theme {
    font-size: 1.5em !important;
  }
  .drawer-cont .registr-block .btn-primary {
    font-size: 0.8em;
  }
  .drawer-cont .registr-block .btn-primary {
    font-size: 12px;
  }
  .drawer-cont .registr-block .ca-btn {
    font-size: 0.8em;
  }
  .drawer-cont .registr-block .ca-btn {
    font-size: 12px;
  }
  .sided-wrapper .left-hand {
    width: 90%;
  }
}

@media screen and (max-width: 374px) {
  .wrapper {
    display: none;
  }
}
</style>
